import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import IconClose from '../../../../images/icons/misc/close.svg';

import styles from './BetslipSettings.module.scss';

const BetslipSettings = ({
  handleSettings,
  setShowBetConfirmation,
  showBetConfirmation
}) => {
  const subtitleClass = classNames({
    [styles.settingsTitle]: true,
    [styles['settingsTitle--subtitle']]: true,
  });

  const buttonClassYes = classNames({
    [styles['button--active']]: showBetConfirmation,
    [styles['button--inactive']]: !showBetConfirmation,
  });

  const buttonClassNo = classNames({
    [styles['button--active']]: !showBetConfirmation,
    [styles['button--inactive']]: showBetConfirmation,
  });


  return (
    <div className={styles.settingsContainer}>
      <div className={styles.settingsTitle}>
        Betslip Settings {(
          <IconClose
            className={styles.rowIcon}
            onClick={() => handleSettings(false)}
          />
        )}
      </div>
      <div className={styles.divider} />
      <div className={subtitleClass}>
        Confirm Bet before placing?
        <div className={styles.confirmBetContainer}>
          <Button
            className={buttonClassYes}
            sizeType="regular"
            buttonType={'alternative'}
            dataHook="betslip-confirm-beforeplacing"
            onClick={() => {
              setShowBetConfirmation(true);
            }}
          >Yes </Button>
          <Button
            className={buttonClassNo}
            sizeType="regular"
            buttonType={'alternative'}
            dataHook="betslip-confirm-beforeplacing"
            onClick={() => {
              setShowBetConfirmation(false);
            }}
          >No</Button>
        </div>
      </div>
    </div>
  );
};

BetslipSettings.propTypes = {
  handleSettings: PropTypes.func.isRequired,
  setShowBetConfirmation: PropTypes.func.isRequired,
  showBetConfirmation: PropTypes.bool.isRequired,
};

export default BetslipSettings;
